import FeedRoute from './FeedRoute';

export default FeedRoute;
